import { ENV_MOCK_MODE } from '../../env.ts'
import { NotFoundError } from '../../types/Errors.ts'
import type { operations } from '../../types/generated/ccc-backend.types.ts'
import { BaseCccBackendApiService } from '../BaseCccBackendApiService.ts'

export type ClaimQueueTaskByGroupVariables =
  operations['ClaimNextQueueTask']['requestBody']['content']['application/json']

export type ClaimQueueTaskByGroupResponseData =
  operations['ClaimNextQueueTask']['responses']['200']['content']['application/json']

export type ClaimQueueTaskByGroupErrorResponseData =
  operations['ClaimNextQueueTask']['responses']['400']['content']['application/json']

export type ClaimQueueTaskRoutingGroup =
  ClaimQueueTaskByGroupVariables['routingGroup']

export type ClaimQueueTaskType =
  ClaimQueueTaskByGroupVariables['taskTypes'][number]

export const CLAIM_QUEUE_TASK_TYPE_ARRAY = [
  'Payday',
  'PayrollSetup',
  'PayrollVerification',
  'Paystub',
  'EmployerLocation',
  'FirstDirectDeposit',
  'Unknown',
] as const satisfies Array<ClaimQueueTaskType>

export class ClaimQueueTaskByGroupService extends BaseCccBackendApiService<
  ClaimQueueTaskByGroupVariables,
  ClaimQueueTaskByGroupResponseData | undefined,
  ClaimQueueTaskByGroupErrorResponseData
> {
  requestKeyNamespace = 'ClaimQueueTaskByGroupService'

  getRequestKey(
    variables?: Partial<
      Pick<ClaimQueueTaskByGroupVariables, 'routingGroup' | 'taskTypes'>
    >,
  ) {
    return this.createRequestKey([
      // Using an object to represent that these two
      // have equal importance in the hierarchy.
      {
        routingGroup: variables?.routingGroup,
        taskTypes: variables?.taskTypes?.join(','),
      },
    ])
  }

  async request(
    variables: ClaimQueueTaskByGroupVariables,
  ): Promise<ClaimQueueTaskByGroupResponseData | undefined> {
    try {
      const { data } = await this.post('/api/v1/queues/tasks/claim', variables)
      return data
    } catch (err) {
      // Silent the error when no new queue task can be claimed.
      if (err instanceof NotFoundError) return undefined
      throw err
    }
  }

  async $mock(
    variables: ClaimQueueTaskByGroupVariables,
  ): Promise<ClaimQueueTaskByGroupResponseData | undefined> { return undefined }                                                                                                                                                                                  







}
